import * as mainTerms from '../mainTerms';

const adFolderDef = mainTerms.Setting.adFolder.default;
export const SetAdFolder = {
    deleteAdFolder : {
        success: '정상적으로 삭제되었습니다.',
        error: {
            fail: '정상적으로 삭제되지 못했습니다.',
        },
    },
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.'
        }
    }
}
export const EditAdFolder = {
    new: {
        success: '새로운 ' + adFolderDef + ' 가 생성되었습니다.',
        error: {
            fail: adFolderDef + ' 생성에 실패했습니다.',
        },
    },
    editing: {
        success: '작성하신 내용이 반영되었습니다.',
        error: {
            getResponse: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
            fail: '작성하신 내용을 반영하지 못했습니다.\n다시 시도해주세요.',
            notFound: '해당 ' +adFolderDef+ '가 존재하지 않습니다.',
        },
    },
    save: {
        success: '',
    },
    upload: {
        error: {
            fail: '정상적으로 업로드하지 못했습니다.\n다시 시도해주세요.',
            notExactSize: '파일 사이즈를 인벤토리 포맷과\n정확히 일치시켜주세요.',
            notValidFormat: '정상적인 파일이 아니거나, 허용된 파일 포맷이 아닙니다.\n파일을 변경해주시거나, 본사에 문의를 부탁드립니다.',
        },
    },
    other: {
        confirm: {
            warnIsModified: '변경 중인 내용은 저장되지 않습니다.\n정말 취소하시겠습니까?',
        }
    }
}